import React from "react";
import Navbar from "@/components/Navbar";
import { Crosshair } from "@/components/Crosshair";
import FoundingSeatPicker from "@/components/founding/FoundingSeatPicker";
import { FoundingCounter } from "@/components/founding/FoundingCounter";

export default function Founding() {
  return (
    <div className="min-h-screen text-foreground" data-testid="founding-page">
      <Navbar />
      <div className="max-w-[760px] mx-auto px-4 py-12">
        <div className="animate-fade-up">
          <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#b08d2c]">Founding Members</span>
          <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter mt-3">
            CLAIM YOUR<br /><span className="text-[#b08d2c]">FOUNDING SEAT</span>
          </h1>
          <p className="mt-4 text-base text-secondary-foreground font-body">
            Founding seats are permanent and numbered. Your seat number stays with you and is
            retired for good if the account ever closes — it means you were here first.
          </p>
          <div className="mt-6">
            <FoundingCounter />
          </div>
        </div>

        <Crosshair className="my-8" />

        <FoundingSeatPicker />

        <p className="mt-6 text-center text-[11px] font-mono uppercase tracking-wide text-muted-foreground">
          Your founding seat number is permanent — retired for good if the account ever closes.
        </p>
      </div>
    </div>
  );
}
